"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_select_1 = require("react-select");
var data_display_1 = require("../../../../data-display");
var layout_1 = require("../../../../layout");
var BaseMultiValue = react_select_1.components.MultiValue;
var SelectChip = function (_a) {
    var size = _a.size, children = _a.children, props = __rest(_a, ["size", "children"]);
    return (react_1.jsx(BaseMultiValue, __assign({}, props),
        react_1.jsx(layout_1.Flex, { gap: 5, alignItems: "center", title: props.data.selectedLabel || props.data.label },
            props.selectType === 'dot' ? (react_1.jsx(data_display_1.Dot, { size: "sm", color: "Success", disabled: props.isDisabled })) : null,
            props.data.imageUrl ? (react_1.jsx(data_display_1.Avatar, { name: "", placeholderType: "icon", size: size === 'sm' ? '3xs' : '2xs', src: props.data.imageUrl, placeholderIcon: props.icon })) : null,
            react_1.jsx("span", { css: { overflow: 'hidden', textOverflow: 'ellipsis', flex: 1 } }, children))));
};
exports.default = SelectChip;
